import { render, staticRenderFns } from "./changepassword90day.vue?vue&type=template&id=1c481e26&scoped=true&lang=html"
import script from "./changepassword90day.vue?vue&type=script&lang=js"
export * from "./changepassword90day.vue?vue&type=script&lang=js"
import style0 from "./changepassword90day.vue?vue&type=style&index=0&id=1c481e26&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c481e26",
  null
  
)

export default component.exports